import { render, staticRenderFns } from "./OzTextButton.vue?vue&type=template&id=684516be&"
import script from "./OzTextButton.vue?vue&type=script&lang=ts&"
export * from "./OzTextButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports